import React, { Component } from "react";
import { translate } from "react-i18next";
import { Link } from "react-router-dom";

import { gaEvent } from "../../ga/analytics";
import {
	CATEGORY_TOP_MENU,
	ACTION_OUR_PRODUCT,
	ACTION_OP_HRTABLE,
	ACTION_OP_MONEYTABLE,
	ACTION_ABOUT_US,
	ACTION_AU_WHO_ARE_WE,
	ACTION_AU_WHAT_WE_DO,
	ACTION_AU_OUR_VISION,
	ACTION_AU_OUR_MISSION,
	ACTION_AU_CORE_VALUE,
	ACTION_AU_OUR_TEAM,
	ACTION_AU_JOIN_OUR_TEAM,
	ACTION_AU_PRIVACY,
	ACTION_BLOG,
	ACTION_OUR_ACTIVITY,
	ACTION_CONTACT_US,
	ACTION_HOME,
	CATEGORY_MONEYTABLE,
	ACTION_TOP_MENU,
	CATEGORY_HRTABLE,
	CATEGORY_CONTACT_US,
	ACTION_AU_TERM_CONDITION,
	ACTION_OP_DAYCASH,
	CATEGORY_DAYCASH,
} from "../../ga/constant";

import { Container, Row } from "../style/global";
import { TopMenu } from "../style/topmenu";

class Topmenu extends Component {
	sendToGa = (type) => {
		if (type === "MoneyTable") {
			gaEvent(CATEGORY_TOP_MENU, ACTION_HOME, this.props.page);
		}

		if (type === "Our Product") {
			gaEvent(CATEGORY_TOP_MENU, ACTION_OUR_PRODUCT, this.props.page);
		}

		if (type === "OP MoneyTable") {
			gaEvent(CATEGORY_TOP_MENU, ACTION_OP_MONEYTABLE, this.props.page);
			gaEvent(CATEGORY_MONEYTABLE, ACTION_TOP_MENU, this.props.page);
		}

		if (type === "OP HRTable") {
			gaEvent(CATEGORY_TOP_MENU, ACTION_OP_HRTABLE, this.props.page);
			gaEvent(CATEGORY_HRTABLE, ACTION_TOP_MENU, this.props.page);
		}

		if (type === "OP DayCash") {
			gaEvent(CATEGORY_TOP_MENU, ACTION_OP_DAYCASH, this.props.page);
			gaEvent(CATEGORY_DAYCASH, ACTION_TOP_MENU, this.props.page);
		}

		if (type === "About Us") {
			gaEvent(CATEGORY_TOP_MENU, ACTION_ABOUT_US, this.props.page);
		}

		if (type === "AU Who") {
			gaEvent(CATEGORY_TOP_MENU, ACTION_AU_WHO_ARE_WE, this.props.page);
		}

		if (type === "AU What") {
			gaEvent(CATEGORY_TOP_MENU, ACTION_AU_WHAT_WE_DO, this.props.page);
		}

		if (type === "AU Vision") {
			gaEvent(CATEGORY_TOP_MENU, ACTION_AU_OUR_VISION, this.props.page);
		}

		if (type === "AU Mission") {
			gaEvent(CATEGORY_TOP_MENU, ACTION_AU_OUR_MISSION, this.props.page);
		}

		if (type === "AU Core Value") {
			gaEvent(CATEGORY_TOP_MENU, ACTION_AU_CORE_VALUE, this.props.page);
		}

		if (type === "AU Our Team") {
			gaEvent(CATEGORY_TOP_MENU, ACTION_AU_OUR_TEAM, this.props.page);
		}

		if (type === "AU Join Our Team") {
			gaEvent(CATEGORY_TOP_MENU, ACTION_AU_JOIN_OUR_TEAM, this.props.page);
		}

		if (type === "AU Term Condition") {
			gaEvent(CATEGORY_TOP_MENU, ACTION_AU_TERM_CONDITION, this.props.page);
		}
		if (type === "AU Privacy") {
			gaEvent(CATEGORY_TOP_MENU, ACTION_AU_PRIVACY, this.props.page);
		}

		if (type === "Blog") {
			gaEvent(CATEGORY_TOP_MENU, ACTION_BLOG, this.props.page);
		}

		if (type === "Activity") {
			gaEvent(CATEGORY_TOP_MENU, ACTION_OUR_ACTIVITY, this.props.page);
		}

		if (type === "Contact Us") {
			gaEvent(CATEGORY_TOP_MENU, ACTION_CONTACT_US, this.props.page);
			gaEvent(CATEGORY_CONTACT_US, this.props.page);
		}
	};

	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		const { t, i18n } = this.props;
		const url_lang = i18n.language === "en" ? "/en" : "";

		return (
			<TopMenu
				hideXS
				className={i18n.language}
				fixedHead={this.props.fixedHead}
			>
				<Container>
					<Row>
						<div className="nav-logo">
							<Link
								to={`${url_lang}/`}
								onClick={() => this.sendToGa("MoneyTable")}
							>
								<img src="/src/images/logo_mt.png" alt="MoneyTable" />
							</Link>
						</div>

						<div className="nav-menu">
							<ul className="nav nav-pills">
								<li
									role="presentation"
									className={`dropdown ${this.state.DDProduct ? "open" : ""}`}
								>
									<a
										className="dropdown-toggle"
										onClick={() => this.sendToGa("Product")}
										data-toggle="dropdown"
										role="button"
										aria-haspopup="true"
										aria-expanded="false"
									>
										{t("tm_product")} <span className="caret"></span>
									</a>
									<ul className="dropdown-menu">
										{/* <li
											className={
												this.props.currentpage === `${url_lang}/moneytable`
													? "active"
													: ""
											}
										>
											<Link
												to={`${url_lang}/moneytable`}
												onClick={() => this.sendToGa("OP MoneyTable")}
											>
												MoneyTable
											</Link>
										</li> */}
										<li
											className={
												this.props.currentpage === `${url_lang}/daycash`
													? "active"
													: ""
											}
										>
											<Link
												to={`${url_lang}/daycash`}
												onClick={() => this.sendToGa("OP DayCash")}
											>
												DayCash
											</Link>
										</li>
									</ul>
								</li>
								<li
									role="presentation"
									className={`dropdown ${this.state.DDAboutus ? "open" : ""}`}
								>
									<a
										className="dropdown-toggle"
										onClick={() => this.sendToGa("Aboutus")}
										data-toggle="dropdown"
										role="button"
										aria-haspopup="true"
										aria-expanded="false"
									>
										{t("tm_aboutus")} <span className="caret"></span>
									</a>
									<ul className="dropdown-menu">
										<li>
											<Link
												to={`${url_lang}/blog`}
												onClick={() => this.sendToGa("Blog")}
											>
												{t("tm_blog")}
											</Link>
										</li>
										<li>
											<Link
												to={`${url_lang}/activity`}
												onClick={() => this.sendToGa("Activity")}
											>
												{t("tm_activity")}
											</Link>
										</li>
										{/* <li><Link to={`${url_lang}/aboutus`} onClick={() => this.sendToGa('AU What')}>{t('f_whatvdo')}</Link></li> */}
										{/* <li>
											<a
												href={`${url_lang}/aboutus#ourmiss`}
												onClick={() => this.sendToGa("AU Mission")}
											>
												{t("f_ourmis")}
											</a>
										</li>
										<li>
											<a
												href={`${url_lang}/aboutus#corevalue`}
												onClick={() => this.sendToGa("AU Core Value")}
											>
												{t("f_coreval")}
											</a>
										</li>
										<li>
											<a
												href={`${url_lang}/aboutus#awarded`}
												onClick={() => this.sendToGa("AU Awarded")}
											>
												{t("f_awarded")}
											</a>
										</li>
										<li>
											<Link
												to={`${url_lang}/ourteam`}
												onClick={() => this.sendToGa("AU Our Team")}
											>
												{t("f_ourtea")}
											</Link>
										</li>
										<li
											className={
												this.props.currentpage === "/career" ? "active" : ""
											}
										>
											<Link
												to={`${url_lang}/career`}
												onClick={() => this.sendToGa("AU Join Our Team")}
											>
												{t("f_jointeam")}
											</Link>
										</li> */}
										{/* <li
											className={
												this.props.currentpage === "/condition" ? "active" : ""
											}
										>
											<Link
												to={`${url_lang}/condition`}
												onClick={() => this.sendToGa("AU Term Condition")}
											>
												{t("f_condition")}
											</Link>
										</li>
										<li
											className={
												this.props.currentpage === "/privacy" ? "active" : ""
											}
										>
											<Link
												to={`${url_lang}/privacy`}
												onClick={() => this.sendToGa("AU Privacy")}
											>
												{t("f_privac")}
											</Link>
										</li> */}
									</ul>
								</li>
								{/* <li
									role="presentation"
									className={
										this.props.currentpage === `${url_lang}/blog`
											? "active"
											: ""
									}
								>
									<Link
										to={`${url_lang}/blog`}
										onClick={() => this.sendToGa("Blog")}
									>
										{t("tm_blog")}
									</Link>
								</li> */}
								{/* <li
									role="presentation"
									className={
										this.props.currentpage === `${url_lang}/activity`
											? "active"
											: ""
									}
								>
									<Link
										to={`${url_lang}/activity`}
										onClick={() => this.sendToGa("Activity")}
									>
										{t("tm_activity")}
									</Link>
								</li> */}
								<li
									role="presentation"
									className={`${url_lang}/contact active`}
								>
									<Link
										to={`${url_lang}/contact`}
										onClick={() => this.sendToGa("Contact Us")}
									>
										{t("tm_contactus")}
									</Link>
								</li>
								{/* <li
									role="presentation"
									className={`red-gg-li ${
										this.props.currentpage === `${url_lang}/promotion`
											? "active"
											: ""
									}`}
								>
									<Link to={`${url_lang}/promotion`}>{t("hot_deal")}</Link>
								</li> */}
							</ul>
						</div>

						{/* <div className="col-lg-8 col-sm-10 col-xs-10 h100">
                          <ul className="nav nav-pills navbar-right ul_main_menu">
                              <li role="presentation" className={`dropdown ${this.state.DDProduct ? 'open' : ''}`}>
                                  <a className="dropdown-toggle" onClick={() => this.sendToGa('Product')} data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                                   {t('tm_product')} <span className="caret"></span>
                                  </a>
                                  <ul className="dropdown-menu">
                                      <li className={this.props.currentpage===`${url_lang}/moneytable`?'active':''}><Link to={`${url_lang}/moneytable`} onClick={() => this.sendToGa('OP MoneyTable')}>MoneyTable</Link></li>
                                      <li className={this.props.currentpage===`${url_lang}/hrtable`?'active':''}><Link to={`${url_lang}/hrtable`} onClick={() => this.sendToGa('OP HRTable')}>HRTable</Link></li>
                                  </ul>
                              </li>
                              <li role="presentation" className={`dropdown ${this.state.DDAboutus ? 'open' : ''}`}>
                                  <a className="dropdown-toggle" onClick={() => this.sendToGa('Aboutus')} data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                                  {t('tm_aboutus')} <span className="caret"></span>
                                  </a>
                                  <ul className="dropdown-menu">
                                      <li><Link to={`${url_lang}/aboutus`} onClick={() => this.sendToGa('AU Who')}>{t('f_whovare')}</Link></li>
                                      <li><Link to={`${url_lang}/aboutus`} onClick={() => this.sendToGa('AU What')}>{t('f_whatvdo')}</Link></li>
                                      <li><a href={`${url_lang}/aboutus#ourvision`} onClick={() => this.sendToGa('AU Vision')}>{t('f_ourvi')}</a></li>
                                      <li><a href={`${url_lang}/aboutus#ourmiss`} onClick={() => this.sendToGa('AU Mission')}>{t('f_ourmis')}</a></li>
                                      <li><a href={`${url_lang}/aboutus#corevalue`} onClick={() => this.sendToGa('AU Core Value')}>{t('f_coreval')}</a></li>
                                      <li><Link to={`${url_lang}/ourteam`} onClick={() => this.sendToGa('AU Our Team')}>{t('f_ourtea')}</Link></li>
                                      <li className={this.props.currentpage==='/career'?'active':''}><Link to={`${url_lang}/career`} onClick={() => this.sendToGa('AU Join Our Team')}>{t('f_jointeam')}</Link></li>
                                      <li className={this.props.currentpage==='/condition'?'active':''}><Link to={`${url_lang}/condition`} onClick={() => this.sendToGa('AU Term Condition')}>{t('f_condition')}</Link></li>
                                      <li className={this.props.currentpage==='/privacy'?'active':''}><Link to={`${url_lang}/privacy`} onClick={() => this.sendToGa('AU Privacy')}>{t('f_privac')}</Link></li>
                                  </ul>
                              </li>
                              <li role="presentation" className={this.props.currentpage===`${url_lang}/blog`?'active':''}>
                                  <Link to={`${url_lang}/blog`} onClick={() => this.sendToGa('Blog')}>{t('tm_blog')}</Link>
                              </li>
                              <li role="presentation" className={this.props.currentpage===`${url_lang}/activity`?'active':''}>
                                  <Link to={`${url_lang}/activity`} onClick={() => this.sendToGa('Activity')}>{t('tm_activity')}</Link>
                              </li>
                              <li role="presentation" className={this.props.currentpage===`${url_lang}/contact`?'active':''}>
                                  <Link to={`${url_lang}/contact`} onClick={() => this.sendToGa('Contact Us')}>{t('tm_contactus')}</Link>
                              </li>
                              <li role="presentation" className={`red-gg-li ${this.props.currentpage===`${url_lang}/promotion`?'active':''}`}>
                                  <Link to={`${url_lang}/promotion`} >{t('hot_deal')}</Link>
                              </li>

                          </ul>
                      </div> */}
					</Row>
				</Container>
			</TopMenu>
		);
	}
}

export default translate("translations")(Topmenu);



// WEBPACK FOOTER //
// ./src/components/layouts/topmenu.jsx